import { shallowEqual, useSelector } from 'react-redux';
import { getUser } from '../selectors';

export const useUser = () => ({
  user: useSelector(getUser, shallowEqual),
});
